enum Authority {
    USER = 'USER',
    ADMIN = 'ADMIN',
    OWNER = 'OWNER',
}

export default Authority;
